module.exports = __webpack_public_path__ + "img/arrow-rotate-left.192a36d0.svg";